// 文件上传相关常量配置
export const FILE_UPLOAD_CONSTANTS = {
  // 文件上传数量限制
  MAX_FILE_COUNT: 10,
  
  // 文件大小限制 (10MB)
  MAX_FILE_SIZE: 10 * 1024 * 1024,
  
  // 文件大小限制描述 (用于显示)
  MAX_FILE_SIZE_MB: 10
};

// 组织相关常量配置
export const ORGANIZATION_CONSTANTS = {
  // 特殊组织ID - 用于判断是否显示特定的模型列表
  COCOROBO_ORG_ID: '45facc0a-1211-11ec-80ad-005056b86db5',
  // COCOROBO_ORG_ID: '45facc0a-1211-11ec-80ad-005056b86db1',
  // 需要执行特定限制（隐藏入口、精简 Tab 等）的组织 ID 列表
  // RESTRICTED_ORG_IDS: ['45facc0a-1211-11ec-80ad-005056b86db5'],
  RESTRICTED_ORG_IDS: ['28aae58a-cab3-11f0-a424-005056924926'],
  // 仅展示的 Header Tab value 列表
  LIMIT_HEADER_TAB_VALUES: [1, 2],
  // 受限组织默认跳转的 Tab value
  RESTRICTED_ORG_DEFAULT_TAB: 1,
  // 学生用户类型(type=2)默认跳转的 Tab value
  STUDENT_DEFAULT_TAB: 1,
  // 受限组织的模型列表配置
  // label: 实际传递的参数
  // nameKey: lang 对象中的 key，用于查找对应的名字（支持多语言）
  //   如果 lang 中没有对应的 key，则使用 nameKey 作为展示名字
  RESTRICTED_ORG_MODEL_LIST: [
    { label: "open-doubao", nameKey: "doubao" },
    { label: "open-Pro/deepseek-ai/DeepSeek-V3", nameKey: "DeepSeek" },
    { label: "open-Pro/deepseek-ai/DeepSeek-R1", nameKey: "DeepSeek-R1" },
    // { label: "open-glm-4.5", nameKey: "glm_4_5" },
    // { label: "open-qwen-plus-latest", nameKey: "thousand_questions_latest" },
    // { label: "open-qwen3-coder-plus", nameKey: "qwen3_coder_plus" },
    // { label: "open-hunyuan-turbo", nameKey: "hunyuan_turbo" },
    // { label: "open-hunyuan-t1-latest", nameKey: "hunyuan_t1_latest" },
  ],

  // 额外组织的模型列表配置（非受限组织，在默认列表基础上按 organizeId 覆盖）
  // key: organizeId
  // value: [{ label, nameKey }, ...]  —— 与 buildModelList 入参保持一致
  ADDITIONAL_ORG_MODEL_LISTS: {
    // 香港教育大学
    "7e23aac4-4aff-11ef-b873-005056b86db5": [
      { label: "open-gpt-5.1", nameKey: "GPT-5.1" },
    ],
    // 示例：
    // 'xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx': [
    //   { label: "open-doubao", nameKey: "doubao" },
    //   { label: "open-Pro/deepseek-ai/DeepSeek-V3", nameKey: "DeepSeek" },
    // ],
  },
};

// 用户类型相关常量配置
export const USER_TYPE_CONSTANTS = {
  // 学生用户类型
  STUDENT_TYPE: 2,
};

// AI模型相关常量配置
export const AI_MODEL_CONSTANTS = {
  // 默认模型
  DEFAULT_MODEL: 'gpt-4o-2024-11-20',
  // 建议生成专用模型
  // SUGGESTION_MODEL: 'glm-4.5-flash'
  // SUGGESTION_MODEL: 'qwen-flash'
  SUGGESTION_MODEL: 'qwen3-max'
};

// 客服智能体相关常量
// export const CUSTOMER_SUPPORT_AGENT_ID_FALLBACK = '9ba6e501-fbbf-4134-ab7c-88b091b5c383';
export const CUSTOMER_SUPPORT_AGENT_ID_FALLBACK = '89533e47-1f4d-4a91-b91a-fe5c3e9392bf';
export const CUSTOMER_SUPPORT_AGENT_ID =
  process.env.VUE_APP_CUSTOMER_SUPPORT_AGENT_ID || CUSTOMER_SUPPORT_AGENT_ID_FALLBACK;


export const CREATE_PPT_PROMPT = `
          请你基于以下{用户输入的内容}，执行以下任务，按要求输出对应内容。

          ## 角色

          你是专业的信息整理专家，擅长根据用户提供的内容，快速梳理出清晰、有条理的PPT内容大纲，能够准确把握关键信息并合理划分层级结构。

          ## 任务

          请你根据用户提供的关键词、一段文本或完整的文本内容，整理出一份详细的PPT内容大纲，大纲需要包含章→页面→组块】三层层级，以帮助用户更好地组织和展示PPT内容。
          请注意，如果用户提供的是一段文本或完整的文本内容，你需要基于用户提供的内容进行【章→页面→组块】的整理，在这个基础上整理出一份详细的PPT内容大纲。

          ## 知识库

          ### PPT大纲结构

          - **章**：是PPT内容的主框架，通常对应一个大的主题或模块，是对整个PPT内容的宏观划分。一个PPT通常包含3-5章。
          - **页面**：是章的细分，属于中观层面的划分，围绕章的主题展开，进一步细化内容，使PPT内容更有层次感。1章通常有3-8个页面。
          - **组块**：是对节内容的具体阐述，是对节的进一步细化，属于微观层面的内容，是PPT内容的具体呈现。一个页面通常有1-4个组块。

          ## 工作流程

          1. 仔细阅读并分析用户提供的关键词、一段文本或完整的文本内容，理解其核心主题和主要内容。
          2. 根据内容的逻辑关系和重要性，划分出【章】的层级，确定PPT的主要模块。
          3. 在每个章的框架下，进一步细化出【页面】的内容，使每个章的内容更加具体和有条理。
          4. 对每个节的内容进行深入分析，提炼出关键的点，构建出1个或多个【组块】，使每个节的内容更加清晰和明确。
          5. 按指定格式输出相应的内容大纲。

          ## 限制/注意事项

          - 在整理大纲时，应保持内容的逻辑性和条理性，确保每个层级的内容都清晰、有条理。
          - 避免生成与用户输入内容无关或不恰当的信息，确保大纲的相关性和实用性。
          - 大纲应简洁明了，避免冗长和复杂的表述，使用户能够快速理解和使用。

          ## 输出

          ### 输出要求

          1. 输出内容为一份详细的PPT内容大纲，包含【章→页面→组块】三层层级。
          2. 大纲应清晰、有条理，能够准确反映用户输入内容的核心主题和主要内容。
          3. 大纲应简洁明了，避免冗长和复杂的表述。
          4. 在输出内容最前面增加一个封面页和目录页，在输出内容的最后增加一个致谢页。
          5. 不要出现“章→页面→组块”这些提示性文字，直接给出相应的标题和内容。

          ### 输出格式

          \`\`\`
          # 封面
          ## 1. 总目录章（章，对应一级数字编号）
          ### 1.1 页面1（为PPT页面中的内容标题，对应二级序号，如1.1；1.1是PPT的目录页）
          #### 1.1.1 组块1
          #### 1.1.2 组块1
          #### 1.1.3 组块1
          ## 2. 第二章（章，对应一级数字编号）
          ### 2.1 页面1（为PPT页面中的内容标题，对应二级序号）
          #### 2.1.1 组块1（为PPT页面中的内容，对应三级序号）
          #### 2.1.2 组块1（为PPT页面中的内容，对应三级序号）
          #### 2.1.3 组块1（为PPT页面中的内容，对应三级序号1）
          ### 2.2 页面（对应一个PPT页面，对应二级序号，如2.1）
          #### 2.2.1 组块1（为PPT页面中的内容，对应三级序号）
          #### 2.2.2 组块2（为PPT页面中的内容，对应三级序号）
          ### 2.3 页面（对应一个PPT页面，对应二级序号，如3.3）
          #### 2.3.1 组块1（为PPT页面中的内容，对应三级序号）
          #### 2.3.2 组块2（为PPT页面中的内容，对应三级序号）
          \`\`\`

          ### 输出示例

          # 2025年就业市场预测

          ## 1. 全球就业市场趋势
          ### 1.1 全球经济复苏与就业增长
          #### 1.1.1 主要经济体的复苏情况
          #### 1.1.2 新兴市场的就业机会
          #### 1.1.3 全球失业率的变化趋势
          ### 1.2 技术驱动的就业转型
          #### 1.2.1 人工智能对就业的影响
          #### 1.2.2 自动化的普及与岗位替代
          #### 1.2.3 新兴技术岗位的需求
          ### 1.3 远程工作的持续影响
          #### 1.3.1 远程工作的普及率
          #### 1.3.2 远程工作对就业结构的影响
          #### 1.3.3 远程工作对员工技能的要求

          ## 2. 行业就业前景分析
          ### 2.1 科技行业
          #### 2.1.1 软件开发与数据科学
          #### 2.1.2 人工智能与机器学习
          #### 2.1.3 网络安全与区块链
          ### 2.2 医疗与健康行业
          #### 2.2.1 远程医疗的兴起
          #### 2.2.2 生物技术与制药
          #### 2.2.3 健康管理与预防医学
          ### 2.3 绿色经济与可持续发展
          #### 2.3.1 可再生能源行业
          #### 2.3.2 环保技术与绿色建筑
          #### 2.3.3 可持续发展咨询

          ## 3. 技能需求与职业发展
          ### 3.1 未来职场核心技能
          #### 3.1.1 数字素养与技术能力
          #### 3.1.2 跨学科协作与沟通能力
          #### 3.1.3 创新与问题解决能力
          ### 3.2 职业转型与终身学习
          #### 3.2.1 职业转型的挑战与机遇
          #### 3.2.2 在线教育与技能提升
          #### 3.2.3 企业培训与员工发展
          ### 3.3 多元化与包容性
          #### 3.3.1 多元化团队的竞争优势
          #### 3.3.2 性别平等与职场包容性
          #### 3.3.3 跨文化沟通与管理

          ## 4. 区域就业市场差异
          ### 4.1 北美就业市场
          #### 4.1.1 美国科技行业的就业趋势
          #### 4.1.2 加拿大绿色经济的机会
          #### 4.1.3 北美远程工作的普及
          ### 4.2 欧洲就业市场
          #### 4.2.1 欧盟的数字化转型
          #### 4.2.2 英国脱欧后的就业影响
          #### 4.2.3 北欧国家的创新就业模式
          ### 4.3 亚太就业市场
          #### 4.3.1 中国科技行业的崛起
          #### 4.3.2 印度IT服务业的持续增长
          #### 4.3.3 东南亚制造业的转型

          ## 5. 政策与法规对就业的影响
          ### 5.1 劳动法与就业保护
          #### 5.1.1 全球劳动法的变化趋势
          #### 5.1.2 零工经济的法律监管
          #### 5.1.3 员工福利与权益保障
          ### 5.2 教育与培训政策
          #### 5.2.1 政府推动的技能培训计划
          #### 5.2.2 高等教育与职业教育的衔接
          #### 5.2.3 企业参与的政策支持
          ### 5.3 移民与人才流动
          #### 5.3.1 全球人才流动的趋势
          #### 5.3.2 移民政策对就业市场的影响
          #### 5.3.3 跨国企业的招聘策略

          ## 6. 未来就业市场的挑战与机遇
          ### 6.1 技术失业与社会不平等
          #### 6.1.1 技术替代岗位的社会影响
          #### 6.1.2 收入差距与就业机会不均
          #### 6.1.3 社会保障体系的应对措施
          ### 6.2 新兴行业的崛起
          #### 6.2.1 元宇宙与虚拟经济
          #### 6.2.2 量子计算与未来科技
          #### 6.2.3 个性化医疗与健康科技
          ### 6.3 全球合作与竞争
          #### 6.3.1 跨国企业的全球布局
          #### 6.3.2 国际人才竞争与合作
          #### 6.3.3 全球供应链对就业的影响
          `;

export const VIDEO_SEARCH_PROMPT = `## 任务
          基于用户提供的内容，提炼出1-3个关键词，用于检索对应的视频。通常的场景是教学场景。
          要求：提取关键的实体/对象，主要的教学对象。正确示范：圆的位置关系、外离圆、外切圆。错误示范：教学目标,实际问题应用，公式应用
          ## 输出
          ### 输出要求
          仅仅返回中文的关键词，以英文的逗号间隔。不要输出“关键词：”这样的提示文本，也不要输出任何其它的内容。
          ### 输出格式
          关键词1,关键词2,关键词3 
          ### 输出示例
          圆与直线的位置关系,外离圆,外切圆`;

// 导出默认配置
export default FILE_UPLOAD_CONSTANTS;
